import { css } from 'styled-components';

export const sizeStyles = css`
  &.double-x-small {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;

    padding: 0 2px;
    border-radius: 8px;

    &.icon-only {
      padding: 0;
    }
  }

  &.x-small {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;

    padding: 2px 4px;
    border-radius: 10px;

    &.icon-only {
      padding: 2px;
    }
  }

  &.small {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;

    padding: 4px 6px;
    border-radius: 10px;

    &.text-only {
      padding: 4px 8px;
    }

    &.icon-only {
      padding: 4px;
    }
  }

  &.medium {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;

    padding: 6px 8px;
    border-radius: 12px;

    &.text-only {
      padding: 6px 12px;
    }

    &.icon-only {
      padding: 6px;
    }
  }

  &.large {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;

    padding: 8px 12px;
    border-radius: 12px;

    &.text-only {
      padding: 8px 16px;
    }

    &.icon-only {
      padding: 8px;
    }
  }

  &.x-large {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;

    padding: 12px 16px;
    border-radius: 16px;

    &.text-only {
      padding: 12px 20px;
    }

    &.icon-only {
      padding: 12px;
    }
  }

  &:not(.vertical-padding) {
    padding-top: 0;
    padding-bottom: 0;
  }
`;
